import React from 'react';
import PropTypes from 'prop-types';
import { IconButton } from 'material-ui';
import TextField from 'material-ui/TextField';
import ControlPointIcon from 'material-ui/svg-icons/image/control-point';
import ContentRemoveIcon from 'material-ui/svg-icons/content/remove-circle-outline';

const styles = {
    textField: {
        floatingLabelStyle: { fontSize: '12px' },
    },
    icon: {
        color: 'rgb(0, 188, 212)',
    },
};

const validateEmail = (email) => {
    if (!email) return '';
    const re = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
    return re.test(email) ? '' : 'Invalid email address';
};

const Emails = ({ 
    emails = [''], 
    onChange,
    error,
}) => {
    const addEmail = () => {
        onChange([...emails, '']);
    };

    const removeEmail = (index) => {
        const newEmails = emails.filter((_, i) => i !== index);
        onChange(newEmails);
    };

    const handleEmailChange = (index, value) => {
        const newEmails = [...emails];
        newEmails[index] = value;
        onChange(newEmails);
    };

    return (
        <React.Fragment>
            {emails.map((email, index) => (
                <div className="row" key={index}>
                    <div className="col-xs-10">
                        <TextField
                            value={email}
                            onChange={e => handleEmailChange(index, e.target.value)}
                            floatingLabelText='Email company'
                            floatingLabelStyle={styles.textField.floatingLabelStyle}
                            fullWidth
                            errorText={validateEmail(email)}
                        />
                    </div>
                    <div className="col-xs-2 center-xs middle-xs" style={{ display: 'flex' }}>
                        {index === 0 ? (
                            <IconButton
                                iconStyle={styles.icon}
                                onClick={addEmail}
                            >
                                <ControlPointIcon />
                            </IconButton>
                        ) : (
                            <IconButton
                                iconStyle={styles.icon}
                                onClick={() => removeEmail(index)}
                            >
                                <ContentRemoveIcon />
                            </IconButton>
                        )}
                    </div>
                </div>
            ))}
        </React.Fragment>
    );
};

Emails.propTypes = {
    emails: PropTypes.arrayOf(PropTypes.string),
    onChange: PropTypes.func.isRequired,
    error: PropTypes.string,
};

export default Emails;



// WEBPACK FOOTER //
// ./app/components/Regions/PortManagement/blocks/ServiceProviders/ServiceProvidersView/Emails.jsx